/**
 * 呼び出すとWindowにSCORM 1.2 APIを追加する
 */

import { LmScorm1_2Api } from './impl/legacy';

import { ILmv6ScormApi } from './api/lmv6';

declare global {
	// tslint:disable-next-line: interface-name
	interface Window {
		/**
		 * SCORM API
		 */
		API: ILmv6ScormApi;
	}
}

window.API = new LmScorm1_2Api();



// WEBPACK FOOTER //
// ./src/logic/scorm/apiFrame.ts